import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { ROW_CHILD_COMPONENT_TYPE } from 'app/constants/browse/rows';
import { rowShape } from 'app/shapes/browse/rows';
import DisplayBibs from 'app/components/shared/browse/DisplayBibs';
import Links from 'app/components/shared/browse/Links';
import Lists from 'app/components/shared/browse/Lists';
import ListsHero from 'app/components/shared/browse/ListsHero';
import Nav from 'app/components/shared/browse/Nav';

import './Rows.scss';

const Rows = ({
  rows,
  trackBibClick,
  trackBibsRowTitleClick,
  trackLinksRowLinkClick,
  trackListCreatorClick,
  trackListImageClick,
  trackListImpression,
  trackListTitleClick,
  trackNavLinkClick
}) => {
  const renderRow = (row, uiContainerPosition) => {
    const { childComponent, rowId, uiContainerType } = row;
    const { mappedProps, type: childComponentType } = childComponent;

    const additionalAnalyticsPayload = { uiContainerPosition, uiContainerType };

    switch (childComponentType) {
      case ROW_CHILD_COMPONENT_TYPE.BIBS:
        return (
          <DisplayBibs
            {...mappedProps}
            additionalAnalyticsPayload={additionalAnalyticsPayload}
            key={rowId}
            trackBibClick={trackBibClick}
            trackTitleClick={trackBibsRowTitleClick}
          />
        );
      case ROW_CHILD_COMPONENT_TYPE.LINKS:
        return (
          <Links
            {...mappedProps}
            additionalAnalyticsPayload={additionalAnalyticsPayload}
            key={rowId}
            trackClick={trackLinksRowLinkClick}
          />
        );
      case ROW_CHILD_COMPONENT_TYPE.LISTS:
        return (
          <Lists
            {...mappedProps}
            additionalAnalyticsPayload={additionalAnalyticsPayload}
            key={rowId}
            trackListCreatorClick={trackListCreatorClick}
            trackListImageClick={trackListImageClick}
            trackListImpression={trackListImpression}
            trackListTitleClick={trackListTitleClick}
          />
        );
      case ROW_CHILD_COMPONENT_TYPE.LISTS_HERO:
        return (
          <ListsHero
            {...mappedProps}
            additionalAnalyticsPayload={additionalAnalyticsPayload}
            key={rowId}
            trackListCreatorClick={trackListCreatorClick}
            trackListImageClick={trackListImageClick}
            trackListImpression={trackListImpression}
            trackListTitleClick={trackListTitleClick}
          />
        );
      case ROW_CHILD_COMPONENT_TYPE.NAV:
        return (
          <Nav
            {...mappedProps}
            additionalAnalyticsPayload={additionalAnalyticsPayload}
            key={rowId}
            trackClick={trackNavLinkClick}
          />
        );
      default:
        /* eslint-disable-next-line no-console */
        console.warn(`Unknown row child component type: ${childComponentType}`);
        return null;
    }
  };

  return (
    <div className="cp-browse-rows">
      {rows.map((row, index) => {
        const uiContainerPosition = index + 1;

        const { hasAlternativeStyle, rowComponentType, rowId } = row;

        const isNav = rowComponentType === ROW_CHILD_COMPONENT_TYPE.NAV;

        const rowContent = renderRow(row, uiContainerPosition);
        if (!rowContent) {
          return null;
        }

        return (
          <section
            className={cn('browse-rows__row', {
              'browse-rows__row--alt': hasAlternativeStyle,
              'browse-rows__row--nav': isNav
            })}
            data-key="browse-rows-row"
            key={rowId}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-12">{rowContent}</div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
};

Rows.propTypes = {
  rows: PropTypes.arrayOf(rowShape).isRequired,
  trackBibClick: PropTypes.func.isRequired,
  trackBibsRowTitleClick: PropTypes.func.isRequired,
  trackLinksRowLinkClick: PropTypes.func.isRequired,
  trackListCreatorClick: PropTypes.func.isRequired,
  trackListImageClick: PropTypes.func.isRequired,
  trackListImpression: PropTypes.func.isRequired,
  trackListTitleClick: PropTypes.func.isRequired,
  trackNavLinkClick: PropTypes.func.isRequired
};

export default Rows;
